import { lighten, Skeleton, Stack } from "@mui/material";
import { BG_COLORS, BORDER_COLORS } from "../../../../constants";

export const PaymentMethodSkeleton = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={3}
      height={90}
      px={3}
      py={2}
      border={`1px solid ${lighten(BORDER_COLORS.default, 0.5)}`}
      borderRadius={1}
      bgcolor={BG_COLORS.default}
    >
      <Stack spacing={0.5} justifyContent="space-between" height="100%">
        <Skeleton height={18} width={70} />
        <Skeleton height={14} width={120} />
        <Skeleton height={14} width={110} />
      </Stack>
      <Stack justifyContent="flex-end" alignItems="flex-end" height="100%">
        <Skeleton variant="rectangular" height={12} width={36} />
      </Stack>
    </Stack>
  );
};
